var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.613,
    height: 15.612,
    viewBox: "0 0 15.613 15.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add",
    transform: "translate(-575.25 -575.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811_-_Outline",
    "data-name": "Path 811 - Outline",
    d: "M580.9,575.25h4.323V580.9h5.645v4.323h-5.645v5.645H580.9v-5.645H575.25V580.9H580.9Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNode);
export default __webpack_public_path__ + "static/media/add_node.a67524d5fb34ba3523285e047508614c.svg";
export { ForwardRef as ReactComponent };